var showHelp = {}
var pjson = require('@/../package.json');


showHelp.GetHelpMessage = function () {
    var aMessage = [];
    aMessage.push({ textbr: "About", textclass: "font-weight-bold" });
    aMessage.push({
        divider: true,
        textbr:
            "Sign up for Fab.nano IAP events.",
    });
    aMessage.push({
        textbr: "This site requires Touchstone authentication to verify your MIT affiliation. You will then sign up with your kerberos.",
    });
    aMessage.push({ textbr: " " });
    aMessage.push({ textbr: "Version", textclass: "font-weight-bold" });
    aMessage.push({ divider: true, textbr: pjson.version });
    aMessage.push({ textbr: " " });
    aMessage.push({
        textbr: "How do I use this page?",
        textclass: "font-weight-bold",
    });
    aMessage.push({ divider: true });
    aMessage.push({
        textbr:
            "After authenticating with Touchstone, you can choose a time slot and upload an image for the event.",
    });
    return aMessage
}

showHelp.GetErrorMessage = function (message) {
    var aMessage = [];
    aMessage.push({ textbr: "Upload Error", textclass: "font-weight-bold" });
    aMessage.push({ divider: true, textbr: "There was an error uploading the data:", });
    aMessage.push({ textbr: message });    
    return aMessage
}

module.exports = showHelp